import { Component } from "react";
import { compose } from "redux";

import Factoring from "./Factoring/Factoring.Component";

import { marketplaceConnector } from "../../../services/marketplace/connector";

import PropTypes from "prop-types";

class MarketplaceComponent extends Component {
  componentDidMount = () => {
    this.props.getOriginators();
  };

  render() {
    return (
      <div className="marketplace-layout body-height content-padding">
        <Factoring {...this.props} />
        <p />
      </div>
    );
  }

  static propTypes = {
    getOriginators: PropTypes.func.isRequired,
  };
}
export default compose(marketplaceConnector)(MarketplaceComponent);
